import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { formatDistanceToNow } from "date-fns";

export default function Messages() {
  const [convs, setConvs] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/conversations"); setConvs(data.conversations || []); }
      catch (e) { setErr(formatApiError(e)); }
    })();
  }, []);

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-rose">Messages</div>
        <h1 className="font-display text-5xl text-navy leading-tight">Your conversations</h1>
        <p className="text-navy/70 mt-2">Only mutual interests appear here. Slow, kind, real.</p>
      </div>

      <div className="space-y-3">
        {convs.length === 0 && (
          <div className="glass rounded-3xl p-8 text-center">
            <div className="font-display text-xl text-navy">No conversations yet.</div>
            <div className="text-navy/60 text-sm mt-1">Head to <Link className="text-rose" to="/app/discover">Discover</Link> and share interest with someone lovely.</div>
          </div>
        )}
        {convs.map((c) => (
          <Link key={c.id} to={`/app/messages/${c.id}`} data-testid={`convo-${c.id}`}
            className="glass rounded-2xl p-5 flex items-center gap-4 hover:-translate-y-0.5 hover:shadow-md transition-all duration-500">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-peach to-rose flex items-center justify-center text-white font-display text-lg">
              {(c.other?.name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("")}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <div className="font-medium text-navy">{c.other?.name}{c.other?.age ? `, ${c.other.age}` : ""}</div>
                {c.last_at && <div className="text-xs text-navy/50">{formatDistanceToNow(new Date(c.last_at), { addSuffix: true })}</div>}
              </div>
              <div className="text-sm text-navy/60 truncate mt-0.5">
                {c.last_message?.text || <span className="italic">Say hello with a thoughtful prompt.</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>

      {err && <div className="text-sm text-rose-600" data-testid="messages-error">{err}</div>}
    </div>
  );
}
